import { render, staticRenderFns } from "./nc-filtering.vue?vue&type=template&id=68a489df&scoped=true"
import script from "./nc-filtering.vue?vue&type=script&lang=js"
export * from "./nc-filtering.vue?vue&type=script&lang=js"
import style0 from "./nc-filtering.vue?vue&type=style&index=0&id=68a489df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a489df",
  null
  
)

export default component.exports